// React
import React from 'react';

// Futurelab
import { ChatListChatRequestChatRoom } from './ChatListChatRequestChatRoom';
import { ChatListChatRequestOption } from './ChatListChatRequestOption';

export function ChatListChatRequestRoom() {
	return (
		<div className="flex min-h-0 flex-1 flex-col overflow-hidden">
			<div className="min-h-0 flex-1">
				<ChatListChatRequestChatRoom />
			</div>
			<div className="shrink-0">
				<ChatListChatRequestOption />
			</div>
		</div>
	);
}
